// import Header from "../components/Header";
// import Sidebar from "../components/Sidebar";

// const AdminLayout = ({ children }) => {
//   return (
//     <>
//       <Header />
//       <div style={{ display: "flex", minHeight: "calc(100vh - 84px)" }}>
//         <Sidebar />
//         <main style={{ flex: 1, padding: "24px", background: "#f5f7fa" }}>
//           {children}
//         </main>
//       </div>
//     </>
//   );
// };

// export default AdminLayout;

import React from "react";
// Explicitly point to the index files to solve the 'Module not found' error
import Header from "../components/Header/index";
import Sidebar from "../components/Sidebar/index";
import "./adminlayout.css";

const AdminLayout = ({ children }) => {
  return (
    <div className="admin-wrapper">
      {/* Top Header */}
      {/* <Header /> */}

      <div className="admin-body">
        {/* Left Sidebar */}
        <Sidebar />

        {/* Main Content Area */}
        <main className="admin-main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
